import { Router } from '@angular/router';
import { environment } from '~env/environment';
import {
  ACCEPTABLE_QUERY_ON_VALUES,
  FLUSH_LOCAL_STORAGE_FEATURES_ON_REFRESH_KEY,
  QUERIES_ACCEPT_OTHER_VALUES,
  LOCALSTORAGE_FEATURES_WHITELIST,
  QUERY_FF_PREFIX,
  RESET_ALL_FEATURES_QUERY_KEY
} from '../constants/feature-flag-query.constant';
import { LocalStorageUtil } from './localstorage.util';

export namespace FeatureFlagQueryUtil {

  const isFlushOnRefresh = (): boolean => {
    return LocalStorageUtil.isFeatureEnabled(FLUSH_LOCAL_STORAGE_FEATURES_ON_REFRESH_KEY);
  };

  const flushQueries = (): void => {
    LocalStorageUtil.bulkRemove(LOCALSTORAGE_FEATURES_WHITELIST);
  };

  const isResetInQuery = (params: Object): boolean => {
    return Object.keys(params).includes(RESET_ALL_FEATURES_QUERY_KEY);
  };

  const isQueryContainFF = (params: Object): boolean => {
    return !!Object.keys(params).find((key) => key.startsWith(QUERY_FF_PREFIX));
  };

  const resetQueryParams = (params: Object, router: Router): void => {
    if (isQueryContainFF(params)) {
      const neutralQueries = Object.keys(params)
        .filter((key) => !key.startsWith(QUERY_FF_PREFIX))
        .reduce((acc, key) => ({
          ...acc, [key]: params[key]
        }), {});
      router.navigate([window.location.pathname], {queryParams: neutralQueries});
    }
  };

  export const initializeLocalStorageFeaturesFromQuery = (router: Router) => {
    const { queryParams } = router.parseUrl(environment.originalUrl());

    if (isResetInQuery(queryParams) || isFlushOnRefresh()) {
      flushQueries();
      resetQueryParams(queryParams, router);
      return;
    }

    if (!isQueryContainFF(queryParams)) {
      return;
    }

    Object.entries(queryParams)
      .reduce((acc, [key, value]) => {
        const isPassPrefix = key.startsWith(QUERY_FF_PREFIX);
        if (!isPassPrefix) {
          return acc;
        }
        const featureKey = key.replace(QUERY_FF_PREFIX, '');
        const isWhitelisted = LOCALSTORAGE_FEATURES_WHITELIST.includes(featureKey);
        return [
          ...acc,
          isWhitelisted ? [featureKey, value]: []
        ];
      }, [])
      .forEach(([key, value]: [string, string]) => {
        if (ACCEPTABLE_QUERY_ON_VALUES.includes(value)) {
          LocalStorageUtil.enableFeature(key);
        } else if(QUERIES_ACCEPT_OTHER_VALUES.includes(key)) {
          LocalStorageUtil.add(key, value);
        } else {
          LocalStorageUtil.disableFeature(key);
        }
      });
  };

}
